import useSWRMutation, { SWRMutationConfiguration } from 'swr/mutation'
import { COMMUNITY_API_PREFIX } from 'shared/api/constants/api-constants'
import { adaptFetcherToSWRMutationFn } from 'shared/api/utils/adapt-fetcher-to-swr-mutation'
import { MOCK_API_PREFIX } from 'shared/constants/api'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { TopicInterface } from '../types/topic-interface'

interface UseUpdateTopicsOrderOptions {
  communityPath: string
  config?: SWRMutationConfiguration<TopicInterface[], Error, string, { orderedTopicIds: number[] }>
}

export const useUpdateTopicsOrder = ({ communityPath, config }: UseUpdateTopicsOrderOptions) => {
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.put,
    TopicInterface[],
    { orderedTopicIds: number[] }
  >({
    method: RequestMethodsEnum.put,
  })

  return useSWRMutation(
    communityPath ? `${COMMUNITY_API_PREFIX}/${communityPath}/topic/order` : null,
    adaptFetcherToSWRMutationFn<TopicInterface[], { orderedTopicIds: number[] }>(fetcher),
    config,
  )
}
